import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  return _objectSpread({
    text: node.textContent,
    headingType: node.nodeName.toLowerCase()
  }, getAdvanced(node));
});